// extracted by mini-css-extract-plugin
export var anchorTitle = "styles-module--anchorTitle--OdEKX";
export var section = "styles-module--section--Mt1jS";
export var anchorTitleText = "styles-module--anchorTitleText--50hSa";
export var backAndForthRight = "styles-module--backAndForthRight--ci2cH";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--N79YM";
export var animateBg = "styles-module--animateBg--VzkoQ";